<template>
	<vs-popup
		:title="$t('indicateFailureReason')"
		class="primary-popup set-ticket-failed"
		:active.sync="activeProp"
	>
		<div>
			<label class="vs-input--label">{{ $t('failureType') }}</label>
			<v-select
				v-model="selectedFailType"
				v-validate="'required'"
				name="failType"
				label="name"
				:options="failType"
				:dir="$vs.rtl ? 'rtl' : 'ltr'"
				:reduce="item => item.value">
			</v-select>
			<span v-if="errors.first('failType')" class="text-danger text-sm">
				{{ $t('fieldFilledIncorrect') }}
			</span>
		</div>

		<div class="my-3">
			<lable class="vs-input--label"> {{ $t('reasonFailed') }}</lable>
			<v-select
				v-model="reason"
				v-validate="'required'"
				name="failedReason"
				label="name"
				:options="filteredFailReason"
				:dir="$vs.rtl ? 'rtl' : 'ltr'"
			>
			</v-select>
			<span v-if="errors.first('failedReason')" class="text-danger text-sm">
				{{ $t('fieldFilledIncorrect') }}
			</span>
		</div>

		<div class="my-3">
			<label class="vs-input--label">{{ $t('causedBy') }}</label>

			<v-select
				v-validate="'required'"
				v-model="caused_by"
				name="causedBy"
				label="name"
				:options="causedBy"
				:dir="$vs.rtl ? 'rtl' : 'ltr'"
			/>
			<span v-if="errors.first('causedBy')" class="text-danger text-sm">
				{{ $t('fieldFilledIncorrect') }}
			</span>
		</div>

		<div class="comment-text my-3">
			<label class="vs-input--label">{{ $t('comment') }}</label>

			<vs-textarea
				v-validate="'required|min:100'"
				class="w-full"
				v-model="comment"
				name="comment"
				:lable="$t('comment')"
				type="textarea"
			>
			</vs-textarea>
			<span v-if="errors.first('comment')" class="text-danger text-sm">
				{{ $t('fieldFilledIncorrect') }}
			</span>
		</div>

		<div class="my-3" v-if="selectedFailType === 'failed_with_payout'">
			<vs-input
				:label="$t('authorsReward')"
				v-model="reward"
				class="reward-input"
				name="reward"
			/>
			<span v-if="errors.first('reward')" class="text-danger text-sm">
				{{ $t('fieldFilledIncorrect') }}
			</span>
		</div>

		<vs-checkbox v-model="notNotifyClientState" class="mt-2 mx-0">
			{{ $t("doNotNotifyClient") }}
		</vs-checkbox>

		<div class="set-ticket-failed__controls">
			<vs-button
				:disabled="loading || !isFormValid"
				color="success"
				@click="confirm">

				{{ $t("confirm") }}
			</vs-button>

			<vs-custom-button
				:disabled="loading"
				color="#9a9a9a"
				type="flat"
				@click="close"
			>
				{{ $t("doCancel") }}
			</vs-custom-button>
		</div>
	</vs-popup>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import vSelect from 'vue-select';

export default {
	name: "SetStageFailedPopup",
	mixins: [databaseManager],

	props: {
		active: { default: false, type: Boolean },
		notNotifyClient: { default: false, type: Boolean },
		loading: { default: false, type: Boolean },
		recommendedPrice: { default: 0 }
	},
	components: {
		vSelect
	},

	data() {
		return {
			selectedFailType: null,
			reason: null,
			failReasons: [],
			reward: 0,
			comment: null,
			caused_by: null,
			is_payout: 0,
		};
	},

	watch: {
		activeProp(newValue) {
			if (newValue === false) {
				this.reason = null;
				this.reward = 0;
			}
		},
		selectedFailType() {
			this.reason = null;
		}
	},

	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			},
		},
		isFormValid() {
			const hasFailType = !!this.selectedFailType;
			const hasReason = !!this.reason;
			const hasCausedBy = !!this.caused_by;
			const hasComment = !!this.comment && this.comment.trim().length > 0;

			if (this.selectedFailType === 'failed_with_payout') {
				return hasFailType && hasReason && hasCausedBy && hasComment && !!this.reward;
			}

			return hasFailType && hasReason && hasCausedBy && hasComment;
		},
		notNotifyClientState: {
			get() {
				return this.notNotifyClient;
			},
			set(val) {
				this.$emit("update:notNotifyClient", val);
			}
		},
		filteredFailReason() {
			if (!this.selectedFailType) return [];

			const typeValue = this.selectedFailType.value || this.selectedFailType;

			if (typeValue === 'failed_with_payout') {
				return this.failReasons.filter(item => item.enabled && item.is_payout === 1);
			}

			if (typeValue === 'failed') {
				return this.failReasons.filter(item => item.enabled && item.is_payout === 0);
			}

			return [];
		},

		causedBy() {
			return [
				{
					name: this.$t('manager'),
					value: 'manager',
				},
				{
					name: this.$t('client'),
					value: 'client',
				},
				{
					name: this.$t('author'),
					value: 'author',
				},
				{
					name: this.$t('agency'),
					value: 'agency',
				},
				{
					name: this.$t('kiNeuroauthor'),
					value: 'ki-neuroauthor',
				}
			];
		},
		failType() {
			return [
				{
					name: this.$t('failed'),
					value: 'failed',
				},
				{
					name: this.$t('failedWithPayout'),
					value: 'failed_with_payout',
				},
			]
		},
	},

	methods: {
		confirm() {
			if (!this.reason) return;

			const userId = this.$store.state.auth.user.user_id;

			this.$emit(
				"confirm",
				{
					reason_id: this.reason.id,
					is_payout: Number(this.reason.is_payout),
				},
				this.reward,
				this.comment,
				this.caused_by.value,
				userId
			);
		},

		close() {
			this.activeProp = false;
		}
	},

	async mounted() {
		this.failReasons = await this.dbGetFailReasons();
	}
};
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.set-ticket-failed {
	.vs__dropdown-menu {
		max-height: 15rem;
	}
	.vs-textarea {
		max-height: 13rem;
	}
	&__title {
		padding-left: 8px;
		padding-right: 8px;
	}

	&__list {
		// padding-left: 8px;
		// padding-right: 8px;
		padding: 0;
		margin-top: 7px;
	}

	&__item {
		margin-top: 5px;
	}

	&__controls {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.vs-popup {
		max-width: 450px !important;
		width: 100% !important;
		padding: 0;

		&--content {
			width: 100%;
			height: 100%;
		}

		&--close,
		&--title h3 {
			color: $primary;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
	}
	.reward-input {
		width: 100%;
	}
}
</style>
